export enum TagTypes {
  SESSION_TAG = 'SESSION_TAG',
  FARMLAND_TAG = 'FARMLAND_TAG',
  TASK_TAG = 'TASK_TAG',
  TASK_ASSIGNMENT_TAG = 'TASK_ASSIGNMENT_TAG',
  EMPLOYEE_TAG = 'EMPLOYEE_TAG',
  MACHINERY_TAG = 'MACHINERY_TAG',
  UNIT_TAG = 'UNIT_TAG',
  DEVICE_TAG = 'DEVICE_TAG',
  CALIBRATION_TAG = 'CALIBRATION_TAG',
}
